import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import Swal from "sweetalert2";
import {
     Typography,
     Table,
     TableBody,
     TableCell,
     TableContainer,
     TableHead,
     TableRow,
     Button,
     Box,
     Paper,
} from "@mui/material";

import DueDateBadge from "@/components/DueDateBadge";
import { fetchWrapper } from "@/helpers/fetch-wrapper"; 
import { getUserData } from "@/utils/userData";
import Link from 'next/link'; 
import { useThemeMode } from "@/contexts/ThemeContext";

const TicketsStatus = () => {
     const { userData } = getUserData();

     const { isDarkMode } = useThemeMode(); 

     const [userTasks, setUserTasks] = useState([]); 

     const fetchUserTasks = async () => {
          try {
               const response = await fetchWrapper.get('/api/admin/tasks'); 
               setUserTasks(response); 
          } catch (err) {
               console.error("Eroare:", err);

          }
     }; 

     const handleDeleteTask = async (id) => {
          try {
               const result = await Swal.fire({
                    title: "Ești sigur?",
                    text: "Vrei să ștergi aceast task ?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Da, șterge!",
                    cancelButtonText: "Nu, anulează!",
               });

               if (result.isConfirmed) {
                    await fetchWrapper.delete("/api/admin/tasks", { id });

                    Swal.fire(
                         "Șters!",
                         "Taskul a fost ștears cu succes.",
                         "success"
                    );

                    fetchUserTasks(); 
               }
          } catch (err) {
               console.error("Eroare la ștergere notă:", err);
               Swal.fire(
                    "Eroare!",
                    "A apărut o eroare la ștergerea task-ului.",
                    "error"
               );
          }
     };
     
     const handleSolutionTask = async (id) => {
          const { isConfirmed } = await Swal.fire({
               title: 'Ești sigur?',
               text: "Vrei să marchezi acest task ca soluționat?",
               icon: 'question',
               showCancelButton: true,
               confirmButtonText: 'Da, marchez!',
               cancelButtonText: 'Anulează',
               reverseButtons: true,
               willOpen: () => {
                    const container = document.querySelector(".swal2-container");
                    if (container) {
                         container.style.zIndex = "100000";
                    }
               },
          });

          if (isConfirmed) {
               try {
                    await fetchWrapper.put('/api/admin/tasks', { id: id });
                    Swal.fire(
                         'Soluționat!',
                         'Task-ul a fost marcat ca soluționat.',
                         'success'
                    );
                    fetchUserTasks(); 
               } catch (error) {
                    console.error("Eroare la marcarea taskului:", error);
                    Swal.fire(
                         'Eroare!',
                         'A apărut o eroare la marcarea taskului.',
                         'error'
                    );
               }
          }
     };

     useEffect(() => {
		fetchUserTasks();
	}, [userData]);

     return (
          <>
               <Card
                    sx={{
                         boxShadow: "none",
                         borderRadius: "10px",
                         p: "25px 25px 10px",
                         mb: "15px",
                    }}
               >
                    {/* Card Header */}
                    <Box
                         sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              borderBottom: "1px solid #EEF0F7",
                              paddingBottom: "10px",
                         }}
                         className='for-dark-bottom-border'
                    >
                         <Typography
                              as='h3'
                              sx={{
                                   fontSize: 18,
                                   fontWeight: 500,
                              }}
                         >
                              <i class="ri-file-list-line"></i> Task-urile mele
                         </Typography>
                    </Box>

                    {/* Table Content */}
                    <Paper elevation={3} sx={{ mt: 2, p: 2, backgroundColor: isDarkMode ? 'black':'white' }}>
                         <TableContainer>
                              <Table>
                                   <TableHead>
                                        <TableRow>
                                             <TableCell>
                                                  <i class="ri-id-card-line"></i> Client
                                             </TableCell>
                                             <TableCell>
                                                  <i class='ri-pencil-line'></i> Titlu
                                             </TableCell>
                                             <TableCell>
                                                  <i class='ri-add-box-line'></i> Adaugat de
                                             </TableCell>
                                             <TableCell>
                                                  <i class='ri-arrow-right-line'></i> Atribuit catre
                                             </TableCell>
                                             <TableCell>
                                                  <i class='ri-time-line'></i> Data limita
                                             </TableCell>
                                             <TableCell>
                                                  <i class="ri-checkbox-circle-line"></i> Status
                                             </TableCell>
                                             <TableCell>
                                                  <i class='ri-tools-line'></i> Acțiuni
                                             </TableCell>
                                        </TableRow>
                                   </TableHead>
                                   <TableBody>
                                        {userTasks.map((task) => (
                                             <TableRow key={task.id}>
                                                  <TableCell><Link href={'/client/' + task.userID}>{task.clientName}</Link></TableCell>
                                                  <TableCell>{task.title}</TableCell>
                                                  <TableCell>{task.byName}</TableCell>
                                                  <TableCell>{task.toName}</TableCell>
                                                  <TableCell>
                                                       <Box sx={{ display: "flex", alignItems: "center" }}>
                                                            <DueDateBadge dueDate={task.dueDate} />
                                                       </Box>
                                                  </TableCell>
                                                  <TableCell>
                                                       <b style={{ color: task.status === 'in curs' ? 'orange' : 'lightgreen' }}>
                                                            {task.status}
                                                       </b>
                                                  </TableCell>
                                                  <TableCell>
                                                       <Button
                                                            style={{ color: "green" }}
                                                            size='small'
                                                            onClick={() => handleSolutionTask(task.id)}
                                                       >
                                                            <i class="ri-calendar-check-line"></i> Solutioneaza
                                                       </Button>

                                                       <Button
                                                            style={{ color: "red" }}
                                                            size='small'
                                                            onClick={() => handleDeleteTask(task.id)}
                                                       >
                                                            <i class='ri-delete-bin-line'></i> Sterge
                                                       </Button>
                                                  </TableCell>
                                             </TableRow>
                                        ))}
                                   </TableBody>
                              </Table>
                         </TableContainer>
                    </Paper>
               </Card>
          </>
     );
};

export default TicketsStatus;
